const types = {
  DIRTY: 'schooladmin/reviewSettings/DIRTY',
  PRISTINE: 'schooladmin/reviewSettings/PRISTINE'
};

const initialState = {
  dirty: false
};

const reviewSettings = (state = initialState, { type }) => {
  switch (type) {
    case types.DIRTY:
      return { dirty: true };

    case types.PRISTINE:
      return { dirty: false };

    default:
      return state;
  }
};

function markDirty() {
  return { type: types.DIRTY };
}

function markPristine() {
  return { type: types.PRISTINE };
}

export const entity = {
  name: 'reviewSettings',
  reducer: reviewSettings,
  actions: {
    ...types,
    markDirty,
    markPristine
  }
};

export default entity.reducer;
